<template>
    <div class="data-aicenter">
	    <div class="page-header" style="margin-bottom: 0;">找平设置</div> 
      <el-row style="padding:15px;text-align: left;">
				<el-col :span="1">
					<div>
						元素：
					</div>
				</el-col>
				<el-col :span="9">
					<el-row v-for="(elms,index) in list" :key="index">
						<el-col :span="6"  style="margin-bottom: 15px;width: 65px;">
							<div :class="elms.elementName.length<=3?'elements single_el':'elements'">
								{{elms.elementName}}
							</div>
						</el-col>
						<el-col :span="18">
							<draggable class="list-group" tag="ul" v-model="elms.balanceList" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="(e)=>moveEnd(e,elms.balanceList)" v-if="elms.balanceList.length > 0">
								<transition-group type="transition" :name="'flip-list'">
									<el-row v-for="(element,index) in elms.balanceList" :key="index" style="cursor:move">
										<el-col :span="3" style="width:25px;">
											<div class="list-group-item list-group-number">
												{{index + 1}}
											</div>
										</el-col>
										<el-col :span="20" style="width:250px;">
											<div class="list-group-item">
												<span class="list-group-content">{{element.ingredientsName}}
                          <span class="del" @click="remove(element.id,element.ingredientsName)">
                            <span style="border: 1px solid rgb(225, 225, 225);height: 1px;width: 20px;margin-bottom: 5px;"></span>
                          </span>
                        </span>
											</div>
										</el-col>
										<el-col :span="1">
										</el-col>
									</el-row>
								</transition-group>
							</draggable>
              <div style="margin-bottom: 10px;margin-left: 35px;margin-top: 8px;">
                <el-select
                    v-model="elms.state"
                    style="width: 230px;"
                    :remote-method="querySearchAsync"
                    placeholder="搜索食材"
                    clearable
                    filterable
                    remote
                    @change="(item)=>handleSelect(item,elms)">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.value"
                        :value="item.id">
                      </el-option>
                  </el-select>
              </div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import { fetchNutritionBalanceList,saveNutritionBalance,removeNutritionBalance } from '@/api/aicenter'
import { queryByKeyWord } from '@/api/catering/ingredient'
export default {
  name: "Balance",
  components: {
    draggable
  },
  data() {
    return {
      list: [],
      editable: true,
      isDragging: false,
      delayedDragging: false,
      options: []
    };
  },
  created() {
    this.orderList();
  },
  methods: {
    orderList() {
      fetchNutritionBalanceList().then(response=>{
        this.list = response.data;
      })
    },
    querySearchAsync(queryString, cb) {
      if(queryString) {
        queryByKeyWord({keyWord:queryString}).then(response=>{
          let result = response.data.map(item=>{
            return {value: item.commonName,id:item.id}
          })
          // cb(result)
          this.options = result;
        })
      }
    },
    handleSelect(val,elms) {
      if(val) {
        let smallObj = this.options.filter(item=>{
          return item.id == val;
        })
        let item = smallObj[0];
        let ingredientsElementName = elms.elementName;
        if(elms.elementCode == 'protein') {
          ingredientsElementName = "蛋";
        }
        if(elms.elementCode == 'carbohydrate') {
          ingredientsElementName = "碳";
        }
        if(elms.elementCode == 'energy') {
          ingredientsElementName = "热";
        }
        if(elms.elementCode == 'a') {
          ingredientsElementName = "VA";
        }
        if(elms.elementCode == 'vb1') {
          ingredientsElementName = "VB1";
        }
        if(elms.elementCode == 'vb2') {
          ingredientsElementName = "VB2";
        }
        if(elms.elementCode == 'c') {
          ingredientsElementName = "VC";
        }
        let ingredient = {ingredientsName: item.value,ingredientsElement: elms.elementCode,ingredientId:item.id,ingredientsElementName: ingredientsElementName};
        elms.balanceList.push(ingredient);
        elms.state = '';
        this.saveNutritionBalance(elms.balanceList)
      }
    },
    moveEnd(e,balanceList) {
      this.saveNutritionBalance(balanceList)
      this.options = []
    },
    remove(id,name) {
      this.$confirm('是否要删除排行食材【'+name+'】', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeNutritionBalance(id).then(response => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.list = response.data;
          });
        });
    },
    saveNutritionBalance(balanceList) {
      saveNutritionBalance(balanceList).then(response=>{
        this.$message.success("设置成功");
        this.list = response.data;
      }); 
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    },
    listString() {
      return JSON.stringify(this.list);
    }
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    }
  }
};
</script>

<style lang="scss">
.list-group {
  min-height: 20px;
	margin: 0;
	padding-left: 10px;
}

.list-group-item {
	font-size: 12px;
	height: 25px;
	margin-bottom: 2px;
	line-height: 25px;
   &:hover .list-group-content{
      background-color:rgb(225, 225, 225);
      .del {
        display: inline-block;
        height: 20px;
        width: 20px;
        position: absolute;
        right: -35px;
        cursor: pointer;
        span {
          display:inline-block;
        }
      }
    }
}
.list-group-number {
	padding-right: 10px;
}
.list-group-content {
	padding-left: 10px;
  background-color: #fafafa;
  display: inline-block;
  width: 230px;
  position: relative;
  .del span{
    display: none;
  }
}
.elements {
	width: 40px;
	height: 40px;
	background-color: rgb(238, 131, 0);
	border: none;
	color: rgb(255, 255, 255);
	border-radius: 5px;
	font-size: 12px;
	padding: 10px 0 0 0;
	text-align: center;
}
.single_el {
	line-height: 40px;
	padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/aicenter/components/balance/index.vue